import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import AccessDeniedComponent from './AccessDeniedComponent';

const AccessDeniedContainer = () => {
  const [message, setMessage] = useState('');
  const [isInspector, setIsInspector] = useState(false);
  const intl = useIntl();
  const navigate = useNavigate();

  useEffect(() => {
    const meStr = window.sessionStorage.getItem('me');
    if (meStr) {
      try {
        const me = JSON.parse(meStr);
        if (me) {
          const isInspectorRole = me.authRole === 'ROLE_INSPECTOR' || me.role === 'ROLE_INSPECTOR';
          const isDisabled = me.status === 'disabled';

          if (!isInspectorRole && !isDisabled) {
            navigate('/', { replace: true });
            return;
          }

          if (isInspectorRole) {
            setMessage(intl.formatMessage({ id: 'INSPECTOR_PANEL_ACCESS_BLOCK_MESSAGE' }));
            setIsInspector(true);
          } else if (isDisabled) {
            setMessage(intl.formatMessage({ id: 'ACCOUNT_BLOCKED_MESSAGE' }));
          } else {
            setMessage(intl.formatMessage({ id: 'PANEL_ACCESS_BLOCK_MESSAGE' }));
          }
        }
      } catch (error) {
        console.debug('Error parsing "me" from sessionStorage', error);
      }
    }
  }, [intl, navigate]);

  return (
    <AccessDeniedComponent message={message}>
      {isInspector && (
        <a
          href="https://play.google.com/store/apps/details?id=br.com.redevistorias.vistorias"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://play.google.com/intl/en_us/badges/static/images/badges/pt-br_badge_web_generic.png"
            alt="Disponível no Google Play"
            className="w-[200px] mt-[20px]"
          />
        </a>
      )}
    </AccessDeniedComponent>
  );
};

export default AccessDeniedContainer;
